import {
  refresher,
  showDialog,
  showDialogWithData,
} from "../../redux/guest-slices/other.slice";
import {
  addCommentReaction,
  createComment,
} from "../../redux/guest-slices/common.slice";
import {
  Avatar,
  Box,
  Button,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";
import { checkUserType, getDiffTime } from "../../utils/helper";
import { COMMENT_REPORT, GUEST_LOGIN } from "../../utils/keywords";
import { useToast } from "../../hooks/useToast";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import InputField1 from "./InputField1";
import { useRef } from "react";

function Comment({ comments = [], reply, setReply }) {
  const toast = useToast();
  const dispatch = useDispatch();
  const commentRef = useRef(null);
  const { blogId, forumId } = useParams();

  // Handle guest login
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN));
  };

  // Handle show reply input
  const handleReplyView = (id) => {
    if (checkUserType()) {
      setReply({ id, view: true });
    } else {
      handleLogin();
    }
  };

  // Handle add comment
  const handleAddComment = async (commentId) => {
    const formData = {
      blogId,
      forumId,
      commentId,
      description: commentRef.current?.value,
    };
    if (!formData?.description || formData?.description?.trim() === "") {
      return toast.error("Please enter comment!");
    }
    const response = await dispatch(createComment(formData));
    if (createComment.fulfilled.match(response)) {
      if (commentRef.current) {
        commentRef.current.value = "";
      }
      dispatch(refresher());
    }
  };

  // Handle comment reaction
  const handleReaction = async (id, type) => {
    if (checkUserType()) {
      await dispatch(addCommentReaction({ id, formData: { type } }));
      dispatch(refresher());
    } else {
      handleLogin();
    }
  };

  // Handle comment report
  const handleReport = (element) => {
    if (checkUserType()) {
      dispatch(
        showDialogWithData({
          data: element,
          type: COMMENT_REPORT,
        })
      );
    } else {
      handleLogin();
    }
  };

  return (
    <>
      {" "}
      {comments && (
        <Stack
          sx={{ p: 2, bgcolor: "white" }}
          spacing={2}
          mt={comments?.length ? 3 : 0}
        >
          {comments?.map((element, i) => (
            <Grid
              key={i}
              container
              spacing={1}
              sx={{
                p: 1,
                borderRadius: 1,
                border: "1px dashed",
                borderColor: "other.color2",
              }}
            >
              <Grid size={12}>
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    sx={{ width: 35, height: 35 }}
                    src={element?.user?.image}
                  />
                  <Box>
                    <Typography
                      mb={0.5}
                      lineHeight="1"
                      variant="body1"
                      fontWeight="500"
                      color="other.color1"
                      textTransform="capitalize"
                    >
                      {element?.user?.fullName}
                    </Typography>
                    <Typography
                      lineHeight="1"
                      fontSize={12}
                      color="other.color2"
                    >
                      {getDiffTime(element?.createdAt)} ago
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid size={12}>
                <Typography>{element?.description}</Typography>
                <Box
                  sx={{
                    gap: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    justifyContent={"start"}
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <Button
                      sx={{
                        fontSize: 14,
                        p: 0.4,
                        lineHeight: 1,
                        ml: "-7px",
                      }}
                      size="small"
                      disableRipple
                      variant="text"
                      color="secondary"
                      onClick={() => {
                        handleReplyView(element?._id);
                      }}
                    >
                      Reply
                    </Button>
                    <Button
                      sx={{
                        fontSize: 14,
                        p: 0.4,
                        lineHeight: 1,
                      }}
                      size="small"
                      disableRipple
                      variant="text"
                      color="secondary"
                      onClick={() => {
                        handleReaction(element?._id, "like");
                      }}
                    >
                      Like ({element?.likes})
                    </Button>
                    <Button
                      sx={{
                        fontSize: 14,
                        p: 0.4,
                        lineHeight: 1,
                      }}
                      size="small"
                      disableRipple
                      variant="text"
                      color="secondary"
                      onClick={() => {
                        handleReaction(element?._id, "dislike");
                      }}
                    >
                      Unlike ({element?.dislikes})
                    </Button>
                  </Box>
                  <Button
                    sx={{
                      ml: "auto",
                      fontSize: 14,
                      lineHeight: 1,
                      p: 0.4,
                    }}
                    size="small"
                    disableRipple
                    variant="text"
                    color="secondary"
                    onClick={() => {
                      handleReport(element);
                    }}
                  >
                    Report
                  </Button>
                </Box>
                {reply?.view && reply?.id === element?._id && (
                  <>
                    <InputField1
                      name="comment"
                      type="textarea"
                      inputRef={commentRef}
                      placeholder="Write your comment here.."
                    />
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{ width: "100%", mt: 1 }}
                      onClick={() => handleAddComment(element?._id)}
                    >
                      Reply
                    </Button>
                  </>
                )}
                <Comment
                  comments={element?.replies}
                  reply={reply}
                  setReply={setReply}
                />
              </Grid>
            </Grid>
          ))}
        </Stack>
      )}
    </>
  );
}

export default Comment;
